import { useTranslation } from 'react-i18next'

import type { GenderType } from '@core/app/types/applyV2Type'

function useGetGenderString(gender?: GenderType | null): string {
    const { t } = useTranslation()
    switch (gender) {
        case 0:
            return '—'
        case 1:
            return t('68')
        case 2:
            return t('69')
        case 3:
            return t('1144')
        case 4:
            return t('8888')
        default:
            return ''
    }
}

export default useGetGenderString
